import script from "./CompanionOverlays.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanionOverlays.vue?vue&type=script&lang=ts&setup=true"

import "./CompanionOverlays.vue?vue&type=style&index=0&id=63d160c2&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63d160c2"]])

export default __exports__